(function () {
  /* ═══════════════════════════════════════════════════════════════
     KONSTANTEN
     ═══════════════════════════════════════════════════════════════ */
  var MODAL_SEL = "#shopLookModal";
  var CONTENT_SEL = "#shopLookContent";
  var CONFIG_SEL = "#stl-config";
  var SLIDER_SEL = ".product-images, product-slider, .flickity-slider";
  var STEP_TRANSITION_MS = 600;
  var BOOT_RETRY_MS = 250;

  /* ═══════════════════════════════════════════════════════════════
     KONFIG aus Metafield-JSON lesen (kein Hardcoding mehr)
     ═══════════════════════════════════════════════════════════════ */
  var cfgEl = document.getElementById(CONFIG_SEL.slice(1));
  if (!cfgEl) return;

  var cfg;
  try {
    cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {
    console.error("Shop the Look: ungültige Config", e);
    return;
  }
  if (!cfg || !cfg.main || !cfg.addons || !cfg.addons.length) return;

  // Rollen: "main" + ein Eintrag pro AddOn-Handle. handles[role] = handle.
  var handles = { main: cfg.main };
  var roles = ["main"];
  cfg.addons.forEach(function (h, i) {
    var role = "addon" + i;
    handles[role] = h;
    roles.push(role);
  });

  var mainRole = "main";
  var config = { mostWanted: cfg.mostWanted || [] };

  /* ═══════════════════════════════════════════════════════════════
     HELPERS
     ═══════════════════════════════════════════════════════════════ */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) {
    s = s == null ? "" : String(s);
    return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  function safeMoney(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return "";
    try { return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(n / 100); }
    catch (e) { return (n / 100).toFixed(2).replace(".", ",") + " €"; }
  }

  function calcSavingsPercent(price, compareAt) {
    var p = Number(price), c = Number(compareAt);
    if (!isFinite(p) || !isFinite(c) || c <= p || c <= 0) return null;
    return Math.round((1 - p / c) * 100);
  }

  /* ═══════════════════════════════════════════════════════════════
     SWATCH-FARBEN AUS DEM THEME-DOM LESEN
     settings.color_swatches → label.swatch → --option-color
     ═══════════════════════════════════════════════════════════════ */
  var swatchColors = null;

  function parseSwatchLabels(root) {
    var colors = {};
    var getById = root.getElementById ? root.getElementById.bind(root) : document.getElementById.bind(document);
    root.querySelectorAll("label.swatch").forEach(function (label) {
      var inputId = label.getAttribute("for");
      var input = inputId ? getById(inputId) : null;
      var name = input ? input.value : label.textContent.trim();
      if (!name || colors[name]) return;

      var style = label.getAttribute("style") || "";
      var hexMatch = style.match(/--option-color:\s*([^;]+)/);
      var imgMatch = style.match(/--option-color-image:\s*url\('([^']+)'\)/);

      colors[name] = {};
      if (hexMatch && hexMatch[1].trim() !== "var(--bg-body)") colors[name].hex = hexMatch[1].trim();
      if (imgMatch) colors[name].image = imgMatch[1];
    });
    return colors;
  }

  function readSwatchColors() {
    return parseSwatchLabels(document);
  }

  function loadAddonSwatchColors(addonHandle, existingColors) {
    return fetch("/products/" + addonHandle)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var addonColors = parseSwatchLabels(doc);
        Object.keys(addonColors).forEach(function (name) {
          if (!existingColors[name]) existingColors[name] = addonColors[name];
        });
        return existingColors;
      })
      .catch(function () { return existingColors; });
  }

  function swatchStyle(colorName) {
    var c = swatchColors ? swatchColors[colorName] : null;
    if (!c) return "background:#ccc;";
    if (c.image) return "background-image:url('" + esc(c.image) + "');background-size:cover;";
    if (c.hex) return "background:" + esc(c.hex) + ";";
    return "background:#ccc;";
  }

  /* ═══════════════════════════════════════════════════════════════
     SHOPIFY API
     ═══════════════════════════════════════════════════════════════ */
  function fetchProduct(handle) {
    return fetch("/products/" + handle + ".js").then(function (r) { return r.json(); });
  }

  function pickVariant(product, colorName) {
    var vs = product.variants;
    if (colorName) {
      return vs.find(function (v) { return v.available && v.option1.toLowerCase() === colorName.toLowerCase(); })
          || vs.find(function (v) { return v.option1.toLowerCase() === colorName.toLowerCase(); })
          || vs[0];
    }
    return vs.find(function (v) { return v.available; }) || vs[0];
  }

  function defaultColor(product) {
    var v = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    return v.option1;
  }

  /* ═══════════════════════════════════════════════════════════════
     STATE
     ═══════════════════════════════════════════════════════════════ */
  var state = {
    products: null,            // { role: productJson }
    loadingPromise: null,
    showSuccessBanner: false,
    selection: {},             // { role: { color, variant, added } }
  };
  roles.forEach(function (r) {
    state.selection[r] = { color: null, variant: null, added: false };
  });

  /* ═══════════════════════════════════════════════════════════════
     PRELOAD – schon beim Einfügen der Buttons Daten ziehen,
     damit das Modal sich beim Klick instant öffnet.
     ═══════════════════════════════════════════════════════════════ */
  function loadAllData() {
    if (state.loadingPromise) return state.loadingPromise;

    if (!swatchColors) swatchColors = readSwatchColors();

    var productFetches = roles.map(function (r) { return fetchProduct(handles[r]); });
    // Swatch-Farben aller AddOn-PDPs nachladen (sequentiell auf bestehendes Objekt mergend)
    var swatchFetches = roles
      .filter(function (r) { return r !== mainRole; })
      .map(function (r) { return handles[r]; });

    state.loadingPromise = Promise.all(productFetches).then(function (productList) {
      state.products = {};
      roles.forEach(function (r, i) { state.products[r] = productList[i]; });

      // Swatches nacheinander mergen, damit existingColors über fetches hinweg wächst
      var swatchChain = Promise.resolve(swatchColors);
      swatchFetches.forEach(function (h) {
        swatchChain = swatchChain.then(function (acc) { return loadAddonSwatchColors(h, acc); });
      });
      return swatchChain;
    }).then(function (finalSwatchColors) {
      swatchColors = finalSwatchColors;

      roles.forEach(function (role) {
        var sel = state.selection[role];
        if (!sel.color) sel.color = defaultColor(state.products[role]);
        sel.variant = pickVariant(state.products[role], sel.color);
      });
    }).catch(function (err) {
      console.error("Shop the Look: Produkt konnte nicht geladen werden", err);
      state.loadingPromise = null;
      throw err;
    });

    return state.loadingPromise;
  }

  /* ═══════════════════════════════════════════════════════════════
     BUTTON EINFÜGEN (via MutationObserver – robust gegen Rerender)
     ═══════════════════════════════════════════════════════════════ */
  var buttonHTML = '<button type="button" class="shop-the-look-btn">'
    + '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">'
    + '<mask id="mask0_1632_26" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16"><rect width="16" height="16" fill="#D9D9D9"></rect></mask>'
    + '<g mask="url(#mask0_1632_26)"><path d="M8.00301 10.1025C8.68045 10.1025 9.25529 9.86538 9.72751 9.39116C10.1997 8.91694 10.4358 8.34111 10.4358 7.66366C10.4358 6.98622 10.1987 6.41138 9.72451 5.93916C9.25029 5.46694 8.67445 5.23083 7.99701 5.23083C7.31956 5.23083 6.74473 5.46794 6.27251 5.94216C5.80029 6.41638 5.56417 6.99222 5.56417 7.66966C5.56417 8.34711 5.80129 8.92194 6.27551 9.39416C6.74973 9.86638 7.32556 10.1025 8.00301 10.1025ZM8.00001 9.46666C7.50001 9.46666 7.07501 9.29166 6.72501 8.94166C6.37501 8.59166 6.20001 8.16666 6.20001 7.66666C6.20001 7.16666 6.37501 6.74166 6.72501 6.39166C7.07501 6.04166 7.50001 5.86666 8.00001 5.86666C8.50001 5.86666 8.92501 6.04166 9.27501 6.39166C9.62501 6.74166 9.80001 7.16666 9.80001 7.66666C9.80001 8.16666 9.62501 8.59166 9.27501 8.94166C8.92501 9.29166 8.50001 9.46666 8.00001 9.46666ZM8.00184 12C6.55784 12 5.24184 11.6071 4.05384 10.8212C2.86584 10.0353 1.97612 8.98377 1.38467 7.66666C1.97612 6.34955 2.86523 5.29805 4.05201 4.51216C5.23879 3.72627 6.55417 3.33333 7.99817 3.33333C9.44217 3.33333 10.7582 3.72627 11.9462 4.51216C13.1342 5.29805 14.0239 6.34955 14.6153 7.66666C14.0239 8.98377 13.1348 10.0353 11.948 10.8212C10.7612 11.6071 9.44584 12 8.00184 12ZM8.00001 11.3333C9.25556 11.3333 10.4083 11.0028 11.4583 10.3417C12.5083 9.68055 13.3111 8.78888 13.8667 7.66666C13.3111 6.54444 12.5083 5.65277 11.4583 4.99166C10.4083 4.33055 9.25556 3.99999 8.00001 3.99999C6.74445 3.99999 5.59167 4.33055 4.54167 4.99166C3.49167 5.65277 2.6889 6.54444 2.13334 7.66666C2.6889 8.78888 3.49167 9.68055 4.54167 10.3417C5.59167 11.0028 6.74445 11.3333 8.00001 11.3333Z" fill="#1C1B1F"></path></g>'
    + '</svg> Shop the Look</button>';

  function insertButtons() {
    var slides = document.querySelectorAll(
      ".flickity-slider > div, .product-images__slide, .product-media-item, .product-media-item__wrapper"
    );
    var added = 0;
    slides.forEach(function (slide) {
      if (!slide.querySelector("img") || slide.querySelector(".shop-the-look-btn")) return;
      if (getComputedStyle(slide).position === "static") slide.style.position = "relative";
      slide.insertAdjacentHTML("beforeend", buttonHTML);
      added++;
    });
    return added;
  }

  function watchSlider() {
    var added = insertButtons();

    if (added > 0 && !state.loadingPromise) {
      loadAllData();
    }

    var slider = $(SLIDER_SEL);
    if (!slider) {
      setTimeout(watchSlider, BOOT_RETRY_MS);
      return;
    }

    new MutationObserver(function () {
      var newAdded = insertButtons();
      if (newAdded > 0 && !state.loadingPromise) loadAllData();
    }).observe(slider, { childList: true, subtree: true });
  }
  watchSlider();

  document.addEventListener("click", function (e) {
    if (!e.target.closest(".shop-the-look-btn")) return;
    e.stopImmediatePropagation();
    e.preventDefault();
    var modal = $(MODAL_SEL);
    if (modal) modal.classList.add("active");
  });

  /* ═══════════════════════════════════════════════════════════════
     RENDER – Step 1 (Produktübersicht)
     ═══════════════════════════════════════════════════════════════ */
  function priceBlockHTML(v) {
    var hasDiscount = v && v.compare_at_price > v.price;
    var pct = calcSavingsPercent(v.price, v.compare_at_price);
    return '<div class="stl-priceLine ' + (hasDiscount ? "is-sale" : "") + '">'
      + (hasDiscount ? '<span class="stl-compare">' + esc(safeMoney(v.compare_at_price)) + '</span>' : "")
      + '<span class="stl-price">' + esc(safeMoney(v.price)) + '</span>'
      + (pct ? '<span class="stl-badge">SPARE ' + pct + '%</span>' : "")
      + '</div>';
  }

  function renderStep1(step1El) {
    step1El.innerHTML = '<div class="stl-step1-title">Shop the Look</div><div class="stl-list"></div>';
    var list = $(".stl-list", step1El);

    roles.forEach(function (role) {
      var p = state.products[role];
      var sel = state.selection[role];
      var v = sel.variant;
      var item = document.createElement("div");
      item.className = "stl-item";

      var checkmark = sel.added ? '<span class="stl-checkmark">✓</span> ' : "";
      var ctaText = sel.added ? 'GEWÄHLT' : 'FARBE WÄHLEN';
      var imgSrc = v.featured_image ? v.featured_image.src : p.featured_image;

      item.innerHTML =
        '<img src="' + esc(imgSrc) + '" class="stl-clickable-img">'
        + '<div class="stl-info-container">'
        + '<div class="stl-title-link">' + esc(p.title) + '</div>'
        + priceBlockHTML(v)
        + '<button type="button" class="stl-cta ' + (sel.added ? "is-added" : "") + '">' + checkmark + ctaText + '</button>'
        + '</div>';

      var goToPDP = function () { window.open("/products/" + handles[role], "_self"); };
      var goToStep2 = function () {
        var step2 = $('[data-step="2"]', step1El.parentNode);
        renderStep2(step2, role);
        step1El.classList.remove("is-active");
        step2.classList.add("is-active");
      };

      item.querySelector(".stl-clickable-img").addEventListener("click", goToPDP);
      item.querySelector(".stl-title-link").addEventListener("click", goToPDP);
      item.querySelector("button").addEventListener("click", function (e) {
        e.stopPropagation();
        goToStep2();
      });
      list.appendChild(item);
    });

    if (state.showSuccessBanner) {
      mountSuccessBanner();
    } else {
      removeSuccessBanner();
    }
  }

  /* Banner sitzt als Sibling von #shopLookContent direkt in
     .shop-look-modal__content (dem scrollenden Container), sodass
     position: sticky; bottom: 0 ihn immer am unteren Modal-Rand hält. */
  function mountSuccessBanner() {
    var modalContent = document.querySelector(".shop-look-modal__content");
    if (!modalContent) return;
    removeSuccessBanner();

    var banner = document.createElement("div");
    banner.className = "stl-success-banner";
    banner.innerHTML =
      '<div class="stl-sb-content">'
      + '<div class="stl-sb-left">'
      + '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>'
      + '<span>Dem Warenkorb hinzugefügt</span>'
      + '</div>'
      + '<span class="stl-sb-link">Ansicht</span>'
      + '</div>';
    banner.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      // SLT-Modal schließen → MutationObserver räumt Scroll-Lock auf,
      // sonst bleibt body.modal-open hängen wenn der Drawer aufgeht.
      var modalEl = $(MODAL_SEL);
      if (modalEl) modalEl.classList.remove("active");
      fetch("/cart.js").then(function (res) { return res.json(); }).then(function (cart) {
        document.dispatchEvent(new CustomEvent("cart:refresh", { detail: cart }));
        window.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
        var astCart = document.querySelector(".ast-cart");
        if (astCart) {
          astCart.classList.add("ast-open");
          var overlay = document.querySelector(".ast-cart-overlay") || document.querySelector(".drawer-overlay");
          if (overlay) overlay.classList.add("is-active");
        } else {
          window.location.href = "/cart";
        }
      });
    });
    modalContent.appendChild(banner);
  }

  function removeSuccessBanner() {
    var existing = document.querySelector(".shop-look-modal__content .stl-success-banner");
    if (existing) existing.remove();
  }

  /* Body-Lock-State aufräumen (idempotent).
     Räumt NUR Body-Klassen + inline Scroll-Lock auf – Cart-App-Drawer-State
     bleibt unangetastet, der wird kontextabhängig anderswo gesetzt. */
  function unlockBody() {
    // Snippet-Frame-JS-Lock
    document.documentElement.classList.remove("modal-open");
    document.body.classList.remove("modal-open");
    // Externe Cart-App body-Lock
    document.body.classList.remove("ast-no-scroll");
    // Snippet-Frame-JS inline Styles (position:fixed Scroll-Trick)
    var top = document.body.style.top;
    var lockedY = top && top.indexOf("-") === 0 ? parseInt(top, 10) : 0;
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
    if (lockedY < 0) window.scrollTo(0, -lockedY);
  }

  /* ═══════════════════════════════════════════════════════════════
     RENDER – Step 2 (Farbauswahl)
     ═══════════════════════════════════════════════════════════════ */
  function renderStep2(step2El, role) {
    var product = state.products[role];
    var sel = state.selection[role];
    var mw = role === mainRole ? (config.mostWanted || []) : [];

    var allColors = [];
    var seen = {};
    product.variants.forEach(function (v) {
      if (!seen[v.option1]) { seen[v.option1] = true; allColors.push(v.option1); }
    });
    var normal = allColors.filter(function (c) { return mw.indexOf(c) === -1; });

    step2El.innerHTML =
      '<div class="stl-step2-scroll">'
      + '<div class="stl-topbar"><button type="button" class="stl-backbtn" data-back>←</button><div class="center">Wähle deine Farbe</div></div>'
      + '<div class="stl-imgrow"></div>'
      + (mw.length ? '<div class="stl-sectionlabel">🔥 MOST WANTED FARBEN: <span class="most-label"></span></div><div class="stl-swatches" id="sw-most"></div>' : "")
      + '<div class="stl-sectionlabel">FARBE: <span class="all-label"></span></div>'
      + '<div class="stl-swatches" id="sw-all"></div>'
      + '<div class="stl-sectionlabel stl-sizelabel">GRÖSSE: <span class="stl-sizevalue">Onesize</span></div>'
      + '</div>'
      + '<div class="stl-bottomBar">'
      + '<div class="stl-deliveryRow"><span class="stl-dot"></span><span class="stl-delivery-text">In 1-3 Tagen bei dir</span></div>'
      + '<div class="stl-priceLine"><span class="stl-compare" data-out-compare></span><span class="stl-price" data-out-price></span><span class="stl-badge" data-out-badge></span></div>'
      + '<button type="button" class="stl-atc" data-atc>IN DEN WARENKORB</button>'
      + '</div>';

    var imgRow = $(".stl-imgrow", step2El);
    var allImgHTML = "";
    product.images.forEach(function (src) {
      if (src) allImgHTML += '<img src="' + esc(src) + '">';
    });
    imgRow.innerHTML = allImgHTML;

    function scrollToVariantImage(v) {
      var pos = null;

      if (v.featured_image && v.featured_image.position) {
        pos = v.featured_image.position;
      } else {
        for (var i = 0; i < product.variants.length; i++) {
          var alt = product.variants[i];
          if (alt.option1 === v.option1 && alt.featured_image && alt.featured_image.position) {
            pos = alt.featured_image.position;
            break;
          }
        }
      }

      if (!pos) return;
      var imgs = imgRow.querySelectorAll("img");
      var targetImg = imgs[pos - 1];
      if (targetImg) imgRow.scrollLeft = targetImg.offsetLeft - imgRow.offsetLeft;
    }

    function updateView(v) {
      sel.variant = v;
      sel.color = v.option1;

      scrollToVariantImage(v);

      var pct = calcSavingsPercent(v.price, v.compare_at_price);
      $("[data-out-price]", step2El).textContent = safeMoney(v.price);
      $("[data-out-compare]", step2El).textContent = v.compare_at_price > v.price ? safeMoney(v.compare_at_price) : "";
      $("[data-out-compare]", step2El).style.display = v.compare_at_price > v.price ? "inline" : "none";
      $("[data-out-badge]", step2El).textContent = pct ? "SPARE " + pct + "%" : "";
      $("[data-out-badge]", step2El).style.display = pct ? "inline-block" : "none";

      var isMW = mw.indexOf(v.option1) > -1;
      var mostLabel = $(".most-label", step2El);
      if (mostLabel) mostLabel.textContent = isMW ? v.option1 : "";
      $(".all-label", step2El).textContent = !isMW ? v.option1 : "";

      $all(".stl-swatch", step2El).forEach(function (b) {
        b.classList.toggle("is-active", b.getAttribute("data-color") === v.option1);
      });
      var atc = $("[data-atc]", step2El);
      atc.disabled = !v.available;
      atc.textContent = v.available ? "IN DEN WARENKORB" : "AUSVERKAUFT";
    }

    function createSwatches(cont, colors) {
      if (!cont) return;
      colors.forEach(function (c) {
        var variant = pickVariant(product, c);
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "stl-swatch" + (variant && !variant.available ? " is-soldout" : "");
        btn.setAttribute("data-color", c);
        btn.innerHTML = '<span style="' + swatchStyle(c) + '"></span>';
        btn.addEventListener("click", function () { updateView(variant); });
        cont.appendChild(btn);
      });
    }

    $("[data-atc]", step2El).addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var btn = this;
      btn.disabled = true;
      btn.textContent = "HINZUFÜGEN...";

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: sel.variant.id, quantity: 1 }),
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        var astCart = document.querySelector(".ast-cart");
        if (astCart) {
          astCart.classList.remove("ast-open");
          var overlay = document.querySelector(".ast-cart-overlay") || document.querySelector(".drawer-overlay");
          if (overlay) overlay.classList.remove("is-active");
        }
        btn.textContent = "HINZUGEFÜGT";
        sel.added = true;
        state.showSuccessBanner = true;
        setTimeout(function () {
          step2El.classList.remove("is-active");
          var step1 = $('[data-step="1"]', step2El.parentNode);
          step1.classList.add("is-active");
          renderStep1(step1);
        }, STEP_TRANSITION_MS);
      })
      .catch(function (err) {
        console.error("Shop the Look: Add to cart fehlgeschlagen", err);
        btn.disabled = false;
        btn.textContent = "IN DEN WARENKORB";
      });
    });

    createSwatches($("#sw-most", step2El), mw);
    createSwatches($("#sw-all", step2El), normal);
    step2El.querySelector("[data-back]").addEventListener("click", function () {
      step2El.classList.remove("is-active");
      var step1 = $('[data-step="1"]', step2El.parentNode);
      step1.classList.add("is-active");
      renderStep1(step1);
    });
    updateView(sel.variant);
  }

  /* ═══════════════════════════════════════════════════════════════
     BOOT – Modal beobachten, beim Öffnen rendern
     ═══════════════════════════════════════════════════════════════ */
  function patch() {
    var content = $(CONTENT_SEL);
    if (!content) return;
    content.setAttribute("data-stl-loading", "true");
    content.innerHTML = '<div class="stl-loader">Lädt...</div>';

    loadAllData().then(function () {
      if (!state.products) return;
      content.innerHTML = '<div data-stl-root="1"><div class="stl-step is-active" data-step="1"></div><div class="stl-step" data-step="2"></div></div>';
      renderStep1($('[data-step="1"]', content));
      content.removeAttribute("data-stl-loading");
      content.setAttribute("data-stl-loaded", "true");
    }).catch(function () {
      content.innerHTML = "";
      content.removeAttribute("data-stl-loading");
    });
  }

  function boot() {
    var modal = $(MODAL_SEL);
    if (!modal) return setTimeout(boot, BOOT_RETRY_MS);

    new MutationObserver(function () {
      var content = $(CONTENT_SEL);
      if (!content) return;
      if (modal.classList.contains("active")) {
        if (!content.querySelector('[data-stl-root="1"]') && !content.hasAttribute("data-stl-loading")) patch();
      } else if (content.hasAttribute("data-stl-loaded")) {
        content.removeAttribute("data-stl-loaded");
        content.innerHTML = "";
        state.showSuccessBanner = false;
        removeSuccessBanner();
        // Defensives Scroll-Lock-Cleanup – läuft IMMER beim Modal-Close,
        // unabhängig davon ob der Frame-JS-Click-Handler vorher gefeuert hat.
        // Idempotent: was schon clean ist, bleibt clean.
        unlockBody();
      }
    }).observe(modal, { attributes: true, attributeFilter: ["class"] });
  }
  boot();
})();
